<template>
  <div>
    <h3 class="title">検索条件</h3>
    <ValidationObserver ref="observer" tag="form">
      <table class="table">
        <tbody>
          <tr>
            <td>企業コード</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="numeric|digits:16">
                <input type="text" :name="itemName.enterpriseCode" class="form-control enterp-codeInput"
                  autocomplete="off" v-model="enterpriseCode" />
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>企業情報作成日</td>
            <td>
              <ValidationProvider class="inline" v-slot="{ errors }" :name="itemName.enterpriseCreateDateFrom" rules="regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$">
                <Datepicker class="inline" v-model="enterpriseCreateDateFrom" input-class="form-control dateInput date1"
                  :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :clear-button="true"
                  :format="formatDateFrom" :language="ja" placeholder="例：2019-01-10"></Datepicker>
                <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
              <span class="inline tilde">～</span>
              <ValidationProvider class="inline" v-slot="{ errors }" :name="itemName.enterpriseCreateDateTo" rules="regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$">
                <Datepicker class="inline" v-model="enterpriseCreateDateTo" input-class="form-control dateInput date2"
                  :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :clear-button="true"
                  :format="formatDateTo" :language="ja" placeholder="例：2019-01-10"></Datepicker>
                <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
        </tbody>
      </table>
    </ValidationObserver>
    <RfidButton :display="'inline'" @handleClick="search">検索</RfidButton>
    <router-link :to="{ name: 'enterprise-edit-new', params: { mode: 'entry' }}"
      class="btn btn-primary btn-lg w200" role="button" aria-pressed="true">新規追加</router-link>
    <br><br>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RfidButton from '@/components/atoms/RfidButton'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'enterprise-search-window',

  components: {
    ValidationProvider,
    ValidationObserver,
    RfidButton,
    Datepicker
  },

  data () {
    return {
      enterpriseCode: '',
      enterpriseCreateDateFrom: '',
      enterpriseCreateDateTo: '',
      itemName: {},
      ja: ja
    }
  },

  created () {
    this.itemName = this.item()
  },

  methods: {
    async search () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('search', this.enterpriseCode, this.enterpriseCreateDateFrom, this.enterpriseCreateDateTo)
    },

    formatDateFrom (value) {
      this.enterpriseCreateDateFrom = this.$moment(value).format('YYYY-MM-DD')
      return this.enterpriseCreateDateFrom
    },

    formatDateTo (value) {
      this.enterpriseCreateDateTo = this.$moment(value).format('YYYY-MM-DD')
      return this.enterpriseCreateDateTo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/EnterpriseSearchWindow.vue